<div class="outline-container">
  @if (!(loading$ | async)) {
    @for (data of keys; track data; let i = $index) {
      <div>{{ '{' }}</div>
      <workflow-context-leaf [key]="data" [context]="contextData" [index]="i" (contextCopied)="copyContext($event)" (refreshView)="refreshView($event)"></workflow-context-leaf>
      <div>{{ '}' }}</div>
    }
  } @else {
    Loading context map... please wait...
  }
</div>
